// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:27:09

export default {
  "id": "witch-and-fairy-bff",
  "slug": "witch-and-fairy-bff",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/85dff0e878384388b23bc0892c2b08c7-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/85dff0e878384388b23bc0892c2b08c7/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Witch & Fairy BFF",
      "description": "Two unusual girlfriends - a Fairy and a Witch - study together, although they are so different. Fairy, with her delicate pink outfits and impeccable sense of style, is always ready to offer fashion tips and create vivid images. Her girlfriend-Witch, who prefers a Gothic style, chooses mysterious and gloomy outfits. Players will be able to help both heroines choose outfits for various events. Join magical friends in their exciting fashion adventure where style and magic go hand in hand!",
      "instructions": "Meet the unusual students of the magic school and help each of them create their own unique fashionable style. The most successful images can be saved at the end of the game as PNG images. Depending on the gaming device, a computer mouse click or a simple touch on touchscreens is used to control it.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "fairy",
        "fashion",
        "hairstyle",
        "magic",
        "witch"
      ]
    },
    "zh-CN": {
      "title": "女巫与精灵闺蜜",
      "description": "两位不寻常的女友——一位仙女和一位女巫——一起学习，尽管她们如此不同。仙女，身着精致的粉色装扮，拥有无可挑剔的时尚感，总是乐于提供时尚建议并创造生动的形象。她的女友女巫，偏爱哥特式风格，选择神秘而忧郁的装扮。玩家将能够帮助这两位女主角为各种活动挑选装扮。加入魔法好友们的激动人心的时尚冒险，在这里风格与魔法相得益彰！",
      "instructions": "遇见魔法学校的奇特学生，帮助他们每个人打造独特的时尚风格。游戏结束时，最成功的形象可以保存为PNG图片。根据游戏设备的不同，使用电脑鼠标点击或触摸屏简单触摸来控制游戏。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "精灵",
        "时尚",
        "发型",
        "魔法",
        "女巫"
      ]
    },
    "zh-TW": {
      "title": "女巫與仙子最佳夥伴",
      "description": "兩位不尋常的女友——一位仙女和一位女巫——一起學習，儘管他們如此不同。仙女，身穿精致的粉紅色裝扮和無懈可擊的時尚感，總是準備好提供時尚建議並創造生動的圖像。她的女友女巫，偏好哥特式風格，選擇神秘而陰鬱的裝扮。玩家將能幫助這兩位女主角為各種活動選擇裝扮。加入這些神奇的友人，一起參與令人興奮的時尚冒險，讓時尚與魔法並肩而行！",
      "instructions": "認識這所魔法學校的特殊學生，並幫助每個學生打造他們獨特的時尚風格。遊戲結束時，最成功的圖片可以存儲為 PNG 圖片。根據遊戲裝置的不同，可以使用電腦鼠標點擊或觸控螢幕簡單觸碰來進行控制。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "仙女",
        "時裝",
        "髮型",
        "魔法",
        "女巫"
      ]
    },
    "zh-HK": {
      "title": "女巫與仙子最佳夥伴",
      "description": "兩位不尋常的女朋友——一位是仙子，另一位是巫婆——他們一起學習，儘管他們如此不同。仙子，她擁有細膩的粉紅色裝扮和無懈可擊的時尚品味，總是準備好提供時尚建議並創造生動的形象。她的女朋友巫婆，則偏愛哥特式風格，選擇神秘而陰沉的裝扮。玩家將能幫助這兩位女主角為各種活動選擇裝扮。加入這些神奇的朋友，一起參與他們刺激的時尚冒險，讓時尚與魔法並肩同行！",
      "instructions": "遇見魔法學校的奇特學生，並幫助他們各自創造獨特的時尚風格。最成功的圖像可在遊戲結束時儲存為PNG圖片。根據遊戲設備，使用電腦滑鼠點擊或觸控螢幕的簡單觸控即可操控。",
      "genres": [
        "打扮装扮"
      ],
      "tags": [
        "仙女",
        "時裝",
        "髮型",
        "魔法",
        "女巫"
      ]
    },
    "ja": {
      "title": "ウィッチ＆フェアリーBFF",
      "description": "二つのユニークなガールフレンド - 精霊と魔女 - が一緒に勉強していますが、彼らは非常に異なっています。精霊は、繊細なピンクの服と完璧なスタイル感覚で、いつもファッションのアドバイスを提供し、鮮やかなイメージを作り出しています。彼女のガールフレンドである魔女は、ゴシックスタイルを好み、神秘的で暗い服を選んでいます。プレイヤーは、両ヒロインが様々なイベント用の服を選ぶのを手伝うことができます。スタイルと魔法が手をつなぐ魅力的なファッション冒険に、魔法の友達と一緒に参加してください！",
      "instructions": "魔法学校のユニークな生徒たちに出会い、それぞれに独自のファッションスタイルを作成する手助けをしましょう。最も成功したイメージは、ゲームの最後にPNG画像として保存できます。ゲームデバイスによっては、コンピューターモウスクリックまたはタッチスクリーンの単純なタッチで操作されます。",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "フェアリー",
        "ファッション",
        "ヘアスタイル",
        "魔法",
        "魔女"
      ]
    },
    "ko": {
      "title": "마녀와仙女의 우정동행",
      "description": "이상한 연인 두 명 - 공주와 사제 - 서로 다른性格으로 공부를 합니다. 공주는 연약한 핑크 아우트핏과 완벽한 스타일감으로 항상 패션 팁을 제공하고 눈에 띄는 이미지를 만들어냅니다. 그녀의 연인 사제는 고딕 스타일을 선호하며, 복잡하고 우울한 아우트핏을 선택합니다. 플레이어들은 이 두 주인공이 다양한 행사에 맞춘 아우트핏을 선택하는 데 도움을 줄 수 있습니다. 스타일과 마법이 손을 잡은 흥미로운 패션 모험에 마법적인 친구들과 함께하세요!",
      "instructions": "마법 학교의 독특한 학생들을 만나고 각 학생이 자신만의 독특한 패션 스타일을 만들어보세요. 가장 성공적인 이미지는 게임이 끝난 후 PNG 이미지로 저장할 수 있습니다. 게임 장치에 따라 컴퓨터 마우스 클릭이나 태치스크린 터치를 사용하여 제어합니다.",
      "genres": [
        "의상장식"
      ],
      "tags": [
        "페어리",
        "패션",
        "헤어스타일",
        "마법",
        "여 wizard"
      ]
    },
    "fr": {
      "title": "Maison Magique et Fée BFF",
      "description": "Deux amies inhabituelles - une Fée et une Sorcière - étudient ensemble, bien qu'elles soient si différentes. La Fée, avec ses tenues roses délicates et son impeccable sens du style, est toujours prête à donner des conseils de mode et à créer des images vivides. Sa compagne la Sorcière, qui préfère un style gothique, choisit des tenues mystérieuses et sombres. Les joueurs pourront aider les deux héroïnes à choisir des tenues pour divers événements. Rejoignez vos amis magiques dans leur aventure de mode passionnante où le style et la magie vont de pair !",
      "instructions": "Rencontrez les élèves atypiques de l'école de magie et aidez chacun à créer leur propre style de mode unique. Les images les plus réussies peuvent être sauvegardées à la fin du jeu sous forme d'images PNG. Selon le périphérique de jeu, un clic avec la souris sur un ordinateur ou un simple toucher sur les écrans tactiles est utilisé pour le contrôler.",
      "genres": [
        "Vêtements de fête"
      ],
      "tags": [
        "fée",
        "mode",
        "coiffure",
        "magie",
        "sorcière"
      ]
    }
  }
};
